/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-console */
/* eslint-disable import/no-named-as-default */
import { Field, Form, Formik } from "formik";
import Cookies from "js-cookie";
import _isEmpty from "lodash/isEmpty";
import _merge from "lodash/merge";
import _omit from "lodash/omit";
import _pick from "lodash/pick";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import CommentsList from "components/lib/Global/CommentsList";
import Button from "components/lib/Shared/Button";
import FileUploadForm from "components/lib/Shared/ChangedDocuments/FileUploadForm";
import SpinnerIcon from "components/lib/Shared/Icons/SpinnerIcon";
import ModalWrapper from "components/lib/Shared/ModalWrapper";
import Overlay from "components/lib/Shared/Overlay";
import ValidationError from "components/lib/Shared/ValidationError";
import TemplateSummary from "components/OrgAndSuperAdminDashboard/TemplatesSettings/Templates/SummaryForm";
import ArticlesOfAssociation from "components/PLCTABS/CompanyFormationTab/CompanyFormationComponents/ArticlesOfAssociation";
import { Constants } from "config/constants";
import { useToast } from "hooks/useToast";
import {
  getCompany,
  step2Attributes,
  updateCompanyAsync,
  updateCompanyState,
} from "state/slices/company";
import { closeModal, openModal } from "state/slices/modals";
import {
  addTemplateAsync,
  deleteTemplateAsync,
  editTemplateAsync,
  updateTemplateState,
} from "state/slices/template";
import { editTemplateVersionAsync } from "state/slices/templateVersion";
import { handleFilesUpload } from "utils/filesUtils";
import articlesValidation from "./validation";
import { te } from "date-fns/locale";
import { template } from "lodash";

const MODAL_NAME = "template_override_confirmation_modal";

const GovernanceSummary = ({ goToPreviousStep, goToNextStep }) => {
  const role = Cookies.get("role");

  const dispatch = useDispatch();
  const { toast, clearAllToasts } = useToast();
  const summaryFormRef = useRef(null);
  const { company } = useSelector((state) => state.companySlice);

  const closeFilePreviewRef = useRef(null);

  const { transformedComments } = useSelector((state) => state.commentsSlice);
  const {
    selectedTemplate,
    selectedVersion,
    getTemplateForApplicant,
    showOverlay,
  } = useSelector((state) => state.templateSlice);
  const { modalRow } = useSelector((state) => state.modalsSlice);

  const { schemaInitialValues, schema } = articlesValidation();

  const companyAttributes = _pick(company, step2Attributes);

  const initialValues = _merge(
    schemaInitialValues,

    companyAttributes
  );

  const articlesOfAssociationToUseComments =
    transformedComments?.["articlesOfAssociation"]
      ?.articlesOfAssociationToUse ?? [];

  const templateVersions = selectedTemplate?.versions
    ? selectedTemplate.versions
    : [];
  const latestTemplate = templateVersions?.[templateVersions.length - 1] ?? {};

  ///get the uploaded articles of association from the already existing corporate
  const existingArticlesOfAssociation =
    company?.initialCorporateData?.fileUploads?.articlesOfAssociation;

  //TODO: LATER ON UPDATE THE SELECTION OF MODEL ARTICLES WITH TWO OPTIONS EITHER USE TABLE(articles before 2015) OR MODEL(articles after 2015)

  return (
    <Formik
      enableReinitialize
      initialValues={{
        ...initialValues,
        resolvedFields: company?.resolvedFields,
        summary: latestTemplate?.summary ?? {},
        fileUploads:
          {
            ...latestTemplate?.fileUploads,
            ...company?.fileUploads,
          } ?? {},
      }}
      validationSchema={schema}
      onSubmit={async (values) => {
        clearAllToasts();

        if (_isEmpty(values.fileUploads)) {
          toast(
            "error",
            "Articles of Association and its Summary are required."
          );
          return;
        }

        if (typeof values?.fileUploads?.template === "object") {
          toast("error", "Upload Articles of Association.");
        }

        // validate summary form
        const summaryFormErrors = await summaryFormRef.current?.validateForm();
        if (!_isEmpty(summaryFormErrors)) {
          summaryFormRef.current.submitForm();
          return;
        }

        if (selectedTemplate?._id && selectedTemplate?.company) {
          const uploadedFiles = await handleFilesUpload(
            values.fileUploads,
            null,
            false,
            "templates"
          );

          //Update company
          await dispatch(
            updateCompanyAsync({
              id: company?._id,
              data: {
                ...values,
                articlesOfAssociation: {
                  ...values?.articlesOfAssociation,
                  template: selectedTemplate._id,
                },
                fileUploads: uploadedFiles,
              },
            })
          );

          //Update the existing template
          const templateData = {
            name: "Articles of Association",
            entityType: company?.type,
            templateType:
              values.articlesOfAssociationToUse ===
              "ModifiedArticlesOfAssociation"
                ? "Short"
                : "Long",
            company: company?._id,
          };

          const updatedTemplate = await dispatch(
            editTemplateAsync({
              templateId: selectedTemplate?._id,
              data: templateData,
            })
          );

          //Update existing version
          const versionData = {
            summary: summaryFormRef.current?.values,
            fileUploads: uploadedFiles,
          };
          const result = await dispatch(
            editTemplateVersionAsync({
              templateVersionId: selectedTemplate?.versions?.[0]?._id,
              data: versionData,
            })
          );

          if (result?.payload?._id) {
            toast("success", "Successfully saved the details");

            dispatch(getCompany({ id: company?._id }));

            goToNextStep();
          } else {
            toast("error", "Something went wrong please try again");
            return;
          }
        } else if (
          existingArticlesOfAssociation &&
          values?.fileUploads?.template === existingArticlesOfAssociation
        ) {
          const uploadedFiles = await handleFilesUpload(
            values.fileUploads,
            null,
            false,
            "templates"
          );

          // create new template
          const templateData = {
            name: "Articles of Association",
            entityType: company?.type,
            templateType:
              values.articlesOfAssociationToUse ===
              "ModifiedArticlesOfAssociation"
                ? "Short"
                : "Long",
            company: company?._id,
            fileUploads: values?.fileUploads,
            summary: summaryFormRef.current?.values,
            templateVersionNumber: 1,
          };

          const response = await dispatch(
            addTemplateAsync({ data: templateData })
          );

          const newTemplate = response.payload?.template ?? response.payload;

          //Update company
          await dispatch(
            updateCompanyAsync({
              id: company?._id,
              data: {
                ..._omit(values, ["fileUploads"]),
                articlesOfAssociation: {
                  ...values?.articlesOfAssociation,
                  template: newTemplate._id,
                },
                fileUploads: uploadedFiles,
              },
            })
          );

          //Update  version
          const versionData = {
            summary: summaryFormRef.current?.values,
            fileUploads: uploadedFiles,
          };
          const result = await dispatch(
            editTemplateVersionAsync({
              templateVersionId: newTemplate?.versions?.[0]?._id,
              data: versionData,
            })
          );

          if (result?.payload?._id) {
            toast("success", "Successfully saved the details");

            dispatch(getCompany({ id: company?._id }));

            goToNextStep();
          } else {
            toast("error", "Something went wrong please try again");
            return;
          }
        }
      }}
    >
      {({
        values,
        errors,
        touched,
        isSubmitting,
        handleSubmit,
        setFieldValue,
      }) => {
        const [uploadingTemplate, setUploadingTemplate] = useState(false);
        const [deletingPreviousTemplate, setDeletingPreviousTemplate] =
          useState(false);

        useEffect(() => {
          setFieldValue("associationChoice", "uploadYourOwn");
          dispatch(
            updateTemplateState({
              selectedTemplate: {},
            })
          );
          if (company?.articlesOfAssociation?.template) {
            dispatch(
              updateTemplateState({
                selectedTemplate: company?.articlesOfAssociation?.template,
              })
            );
          }
        }, [
          values.articlesOfAssociationToUse,
          values.associationChoice,
          company?.type,
          company?.fileUploads,
        ]);

        const handleChangeArticlesOfAssociationToUse = (e) => {
          const { name, value } = e.target;
          if (
            company?.articlesOfAssociation?.template &&
            !(values?.fileUploads?.template === existingArticlesOfAssociation)
          ) {
            dispatch(
              openModal({ modalName: MODAL_NAME, modalRow: { name, value } })
            );
          } else {
            setFieldValue(e.target.name, value);
          }
        };

        const handleChangeAssociationChoice = (e) => {
          const { name, value } = e.target;
          if (company?.articlesOfAssociation?.template) {
            dispatch(
              openModal({ modalName: MODAL_NAME, modalRow: { name, value } })
            );
          } else {
            setFieldValue(e.target.name, value);
          }
        };

        useEffect(() => {
          if (
            values.associationChoice &&
            latestTemplate?.fileUploads?.template
          ) {
            setFieldValue("summary", latestTemplate.summary);
            setFieldValue("fileUploads", {
              ...(company?.fileUploads ?? {}),
              ...latestTemplate.fileUploads,
            });
          } else if (existingArticlesOfAssociation) {
            setFieldValue("summary", {});
            setFieldValue("fileUploads", {
              template: existingArticlesOfAssociation,
            });
          } else {
            setFieldValue("summary", {});
            setFieldValue("fileUploads", company?.fileUploads ?? {});
          }
        }, [
          latestTemplate?.fileUploads?.template,
          values.associationChoice,
          company?.fileUploads,
          values?.articlesOfAssociationToUse,
        ]);

        const handleUploadTemplate = async () => {
          try {
            if (!values.fileUploads?.template) return;
            setUploadingTemplate(true);
            setFieldValue("fileUploads", company?.fileUploads ?? {});
            // remove previous template
            await handleRemovePreviousTemplate();
            const uploadedFiles = await handleFilesUpload(
              values.fileUploads,
              null,
              false,
              "templates"
            );

            // create new template
            const templateData = {
              name: "Articles of Association",
              entityType: company?.type,
              templateType:
                values.articlesOfAssociationToUse ===
                "ModifiedArticlesOfAssociation"
                  ? "Short"
                  : "Long",
              company: company?._id,
              fileUploads: uploadedFiles,
              summary: values?.summary,
              templateVersionNumber: 1,
            };
            const response = await dispatch(
              addTemplateAsync({ data: templateData })
            );
            const newTemplate = response.payload?.template ?? response.payload;
            dispatch(
              updateTemplateState({
                selectedTemplate: newTemplate,
              })
            );
            await dispatch(
              updateCompanyAsync({
                id: company?._id,
                data: {
                  ..._omit(values, ["fileUploads"]),
                  articlesOfAssociation: {
                    ...company.articlesOfAssociation,
                    ...values.articlesOfAssociation,
                    template: newTemplate._id,
                  },
                },
              })
            );
            setFieldValue("fileUploads", uploadedFiles);
          } catch (error) {
            toast("error", "Something went wrong please try again");
          } finally {
            setUploadingTemplate(false);
          }
        };

        const handleRemovePreviousTemplate = async () => {
          try {
            setDeletingPreviousTemplate(true);
            if (selectedTemplate?._id) {
              await dispatch(
                deleteTemplateAsync({ templateId: selectedTemplate._id })
              );
            }
            await dispatch(
              updateCompanyAsync({
                id: company?._id,
                data: {
                  ..._omit(values, ["fileUploads"]),
                  articlesOfAssociation: {
                    ...values.articlesOfAssociation,
                    template: null,
                  },
                },
              })
            );
            const companyData = {
              fileUploads: {},
              articlesOfAssociation: {
                ...values.articlesOfAssociation,
                template: null,
              },
            };
            dispatch(updateCompanyState(companyData));
            dispatch(
              updateTemplateState({
                selectedTemplate: {},
              })
            );
            setFieldValue("summary", {});
            setFieldValue("fileUploads", company?.fileUploads ?? {});
            if (modalRow?.name) {
              setFieldValue(modalRow.name, modalRow.value);
              dispatch(closeModal(MODAL_NAME));
            }
          } catch (error) {
            toast("error", "Something went wrong please try again");
          } finally {
            setDeletingPreviousTemplate(false);
          }
        };

        return (
          <Form>
            <fieldset
              disabled={role === Constants.COOKIE_ROLES.OFFICIAL || showOverlay}
              className="relative"
            >
              {showOverlay && <Overlay />}

              <div>
                <div className="mb-4 shadow-sm sm:rounded-md sm:overflow-hidden">
                  <div className="px-4 py-6 space-y-4 bg-white sm:p-6">
                    <div className="inline-block">
                      <p className="relative">
                        <span className="font-medium">
                          ARTICLES OF ASSOCIATION (Select the option that
                          applies)
                        </span>
                        {articlesOfAssociationToUseComments.length > 0 && (
                          <span className="absolute flex items-center justify-center p-1 h-4 text-white bg-red-700 rounded-full -top-2 -right-5">
                            <span>
                              {articlesOfAssociationToUseComments.length}
                            </span>
                          </span>
                        )}
                      </p>
                    </div>
                    <div className="flex items-center">
                      <Field
                        name="articlesOfAssociationToUse"
                        type="radio"
                        id="ModelArticlesOfAssociation"
                        value="ModelArticlesOfAssociation"
                        onChange={handleChangeArticlesOfAssociationToUse}
                        className="w-4 h-4 text-sflPrimary border-gray-300 focus:ring-green-focused disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none disabled:cursor-not-allowed"
                        disabled={values.resolvedFields.includes(
                          "articlesOfAssociationToUse"
                        )}
                      />
                      <label
                        htmlFor="ModelArticlesOfAssociation"
                        className="block ml-3 text-sm font-medium text-gray-700"
                      >
                        The company adopted the model articles of association
                        applicable to a{" "}
                        {company?.type === "PVT"
                          ? "private company"
                          : "public company"}
                      </label>
                    </div>
                    <div className="flex items-center">
                      <Field
                        name="articlesOfAssociationToUse"
                        type="radio"
                        id="ModifiedArticlesOfAssociation"
                        value="ModifiedArticlesOfAssociation"
                        onChange={handleChangeArticlesOfAssociationToUse}
                        className="w-4 h-4 text-sflPrimary border-gray-300 focus:ring-green-focused disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none disabled:cursor-not-allowed"
                        disabled={values.resolvedFields.includes(
                          "articlesOfAssociationToUse"
                        )}
                      />
                      <label
                        htmlFor="ModifiedArticlesOfAssociation"
                        className="block ml-3 text-sm font-medium text-gray-700"
                      >
                        The company adopted some of those model articles and
                        prepared its own articles of association to supplement
                        or modify those model articles
                      </label>
                    </div>
                    <div className="flex items-center">
                      <Field
                        name="articlesOfAssociationToUse"
                        type="radio"
                        id="OwnArticlesOfAssociation"
                        value="OwnArticlesOfAssociation"
                        onChange={handleChangeArticlesOfAssociationToUse}
                        className="w-4 h-4 text-sflPrimary border-gray-300 focus:ring-green-focused disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none disabled:cursor-not-allowed"
                        disabled={values.resolvedFields.includes(
                          "articlesOfAssociationToUse"
                        )}
                      />
                      <label
                        htmlFor="OwnArticlesOfAssociation"
                        className="block ml-3 text-sm font-medium text-gray-700"
                      >
                        The company prepared its own articles of association
                      </label>
                    </div>
                    {values.articlesOfAssociationToUse && (
                      <div className="m-4 p-4 bg-gray-100 space-y-2 sm:rounded-md sm:overflow-hidden">
                        <div className="flex items-center">
                          <Field
                            name="associationChoice"
                            type="radio"
                            id="uploadYourOwnOption"
                            value="uploadYourOwn"
                            onChange={handleChangeAssociationChoice}
                            className="w-4 h-4 text-sflPrimary border-gray-300 focus:ring-green-focused disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none disabled:cursor-not-allowed"
                            disabled={values.resolvedFields.includes(
                              "associationChoice"
                            )}
                          />
                          <label
                            htmlFor="uploadYourOwnOption"
                            className="block ml-3 text-sm font-medium text-gray-700"
                          >
                            Uploading your own articles of association
                          </label>
                        </div>
                        {getTemplateForApplicant.status === "loading" && (
                          <div className="flex justify-center mx-auto mt-10 text-white">
                            <SpinnerIcon className="text-gray-400" />
                          </div>
                        )}

                        {values.associationChoice === "uploadYourOwn" && (
                          <div>
                            <Field
                              name="fileUploads"
                              component={FileUploadForm}
                              documentData={[
                                {
                                  label: "",
                                  name: "template",
                                  accept: ".pdf, ",
                                },
                              ]}
                              innerRef={closeFilePreviewRef}
                              editorParams={{
                                containerHeight: "900px",
                              }}
                              folder="templates"
                            />
                            {["object", "undefined"].includes(
                              typeof values?.fileUploads?.template
                            ) && (
                              <div className="flex justify-end">
                                <Button
                                  onClick={handleUploadTemplate}
                                  disabled={!values.fileUploads?.template}
                                  isLoading={uploadingTemplate}
                                  loadingText="Uploading..."
                                >
                                  Upload
                                </Button>
                              </div>
                            )}
                            {typeof values.fileUploads.template ===
                              "string" && (
                              <TemplateSummary
                                ref={summaryFormRef}
                                selectedVersion={{
                                  summary: values.summary,
                                  fileUploads: values.fileUploads,
                                }}
                                comments={
                                  transformedComments.articlesOfAssociation
                                }
                              ></TemplateSummary>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                    {articlesOfAssociationToUseComments.length > 0 && (
                      <CommentsList
                        comments={articlesOfAssociationToUseComments}
                        color={"text-red-500"}
                      />
                    )}
                    <ValidationError
                      errors={errors}
                      touched={touched}
                      name="articlesOfAssociationToUse"
                    />
                  </div>
                </div>
                <Field
                  name="articlesOfAssociation"
                  component={ArticlesOfAssociation}
                  transformedComments={transformedComments}
                />
              </div>
            </fieldset>
            <div className="flex justify-between items-center mt-6">
              <Button
                variant="text"
                className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-gray-600 border border-transparent rounded-md shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 disabled:cursor-not-allowed"
                onClick={goToPreviousStep}
              >
                Go Back
              </Button>
              <Button
                onClick={handleSubmit}
                isLoading={isSubmitting}
                className="flex px-2 py-2 text-white button button-hover button-disabled button-outline button-focus bg-sflPrimary"
              >
                Save and proceed
              </Button>
            </div>
            <ModalWrapper
              name={MODAL_NAME}
              title="Warning"
              titleColor="text-red-500"
              maxWidth="sm:max-w-[35%]"
            >
              <div className="my-4 text-lg">
                You will lose all data relating to the articles of association
                you have provided so far.
              </div>
              <hr />
              <div className="flex justify-end mt-4 space-x-4">
                <Button
                  onClick={() => dispatch(closeModal(MODAL_NAME))}
                  variant="outline"
                  disabled={deletingPreviousTemplate}
                >
                  Cancel
                </Button>
                <Button
                  variant="danger"
                  onClick={handleRemovePreviousTemplate}
                  loadingText="Removing..."
                  isLoading={deletingPreviousTemplate}
                >
                  Proceed
                </Button>
              </div>
            </ModalWrapper>
          </Form>
        );
      }}
    </Formik>
  );
};

export default GovernanceSummary;
